import { useEffect } from 'react';

import { useAppContext } from '../../../../AppModulesWrapper';
import { useTelemetry } from '../../../../common/hooks';

export const useScriptsLoadingErrorsLogger = () => {
  const { logger, webview } = useAppContext();
  const { increment } = useTelemetry();

  useEffect(() => {
    // Вызов метода нужен для отправки события @@APP-INIT при старте
    // Если не загрузились стили, то считаем, что приложение не готово к запуску
    if (!window.STYLES_LOADING_ERROR_LINKS?.length) {
      // as any временный костыль, пока платформа не поправит интерфейс
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (webview as any).appInit?.();
    } else {
      logger.error('Scripts loading error', {
        scripts: window.STYLES_LOADING_ERROR_LINKS,
        message: 'Не были загружен ресурсы из CDN',
      });

      increment('scriptsLoadingErrors');

      window.STYLES_LOADING_ERROR_LINKS = [];
    }
  }, [logger, increment, webview]);
};
